import { default as NewsItem } from './NewsItem'
export { default as NewsItemReducer } from './model/slice'
export default NewsItem
